import {namespace} from 'vuex-class';
import {Module} from 'vuex';
import {SET_SNACKBAR} from '@/store/mutationTypes';
import {RootState} from '@/types';

interface SnackbarState {
  options: SnackbarOptions;
}

export type SnackbarColor =
  | 'primary'
  | 'success'
  | 'warning'
  | 'error'
  | 'secondary'
  | 'info';

export interface SnackbarOptions {
  color?: SnackbarColor | string;
  mode?: string;
  show?: boolean;
  text: string;
  timeout?: number;
  x?: string | null;
  y?: string | null;

  [key: string]: any;
}

export const snackbarModule = namespace('snackbar');

export default <Module<SnackbarState, RootState>>{
  namespaced: true,
  state: {
    options: {
      color: 'info',
      mode: '',
      show: false,
      text: '',
      timeout: 3000,
      x: null,
      y: null,
    },
  },
  mutations: {
    [SET_SNACKBAR](state: SnackbarState, options: SnackbarOptions) {
      state.options = {...state.options, ...options};
    },
  },
  actions: {
    fire({commit}, options: SnackbarOptions) {
      commit(SET_SNACKBAR, options);
    },
    show({commit}, {message, color, options}) {
      commit(SET_SNACKBAR, {
        show: true,
        text: message,
        color,
        ...options,
      });
    },
    hide({commit}) {
      commit(SET_SNACKBAR, {
        show: false,
        text: '',
      });
    },
  },
  getters: {},
};
